import styled from 'styled-components'

const StyledDesignerUploadsPanel = styled.div``

export default StyledDesignerUploadsPanel
